import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Navbar from './components/navBar';
import EditJob from './components/editjob';
import Login from './components/login';
import HomePage from './pages/homePage';
import WeatherWidget from './components/weatherWidget';
import ProtectedRoute from './components/protectedRoute';
import AddressPage from './pages/addressesPage';
import CustomersPage from './pages/customersPage';
import LicensePage from './pages/licensePage';
import MapPage from './pages/mapPage';
import EmployeePage from './pages/employeePage';
import DispatchPage from './pages/dispatchPage';
import InventoryPage from './pages/inventoryPage';
import InventoryReportPage from './pages/inventoryReportPage';
import InvoiceDetails from './pages/invoiceDetailsPage';
import JobDetails from './pages/jobDetailsPage';
import Modal from 'react-modal';
import Footer from './components/footer';
import { JobsProvider } from './components/jobContext';
import { TokenValidationProvider } from './components/tokenValidationContext';
import { SelectionProvider } from './components/selectionContext';


import './App.css';
import PaymentSuccessPage from './pages/paymentSuccessPage';
import PaymentCancelPage from './pages/paymentCancelPage';
import PaymentsPage from './pages/paymentsPage';
import PaymentSettingsPage from './pages/paymentSettingsPage';
import PortalPage from './pages/portalPage';
import EditLicense from './pages/licensePage/components/editLicense';
import Notifications from './components/Notifications';
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

Modal.setAppElement('#root');  // Improves accessibility

function App() {
  return (
    <JobsProvider>
      <SelectionProvider>
          <Router>
          <TokenValidationProvider>
            <Notifications/>
            <div className="App">
              <header className="App-header">
                <WeatherWidget />
                <Navbar />
              </header>

              <Routes>
                <Route
                  path="/"
                  element={
                    <ProtectedRoute>
                      <HomePage />
                    </ProtectedRoute>
                  }
                />

                <Route path="/invoice/:guid" element={<InvoiceDetails />} />
                <Route path="/job/:guid" element={<JobDetails />} />

                <Route path="/edit-job/:jobId" element={
                    <ProtectedRoute>
                      <EditJob />
                    </ProtectedRoute>
                } />

                <Route path="/addresses" element={
                    <ProtectedRoute>
                      <AddressPage />
                    </ProtectedRoute>
                } />

                <Route path="/customers" element={
                    <ProtectedRoute>
                      <CustomersPage />
                    </ProtectedRoute>
                } />

                <Route path="/license" element={
                    <ProtectedRoute>
                      <LicensePage />
                    </ProtectedRoute>
                } />

                <Route path="/license-edit/:licenseId" element={
                    <ProtectedRoute>
                      <EditLicense />
                    </ProtectedRoute>
                } />

                <Route path="/map" element={
                    <ProtectedRoute>
                      <MapPage />
                    </ProtectedRoute>
                } />

                <Route path="/staff" element={
                    <ProtectedRoute>
                      <EmployeePage />
                    </ProtectedRoute>
                } />

                <Route path="/dispatch" element={
                    <ProtectedRoute>
                      <DispatchPage />
                    </ProtectedRoute>
                } />

                <Route path="/inventory" element={
                    <ProtectedRoute>
                      <InventoryPage />
                    </ProtectedRoute>
                } />

                <Route path="/inventory/report" element={
                    <ProtectedRoute>
                      <InventoryReportPage />
                    </ProtectedRoute>
                } />

                
                <Route path="/payment-success" element={<PaymentSuccessPage />} />
                <Route path="/payment-cancel" element={<PaymentCancelPage />} />
                <Route path="/payments/:guid" element={<PaymentsPage />} />
                <Route path="/payment-settings" element={<ProtectedRoute><PaymentSettingsPage /></ProtectedRoute>} />

                <Route path="/portal" element={
                    <ProtectedRoute>
                      <PortalPage />
                    </ProtectedRoute>
                } />


                <Route path="/login" element={<Login />} />
              </Routes>
            </div>
                
            <Footer />
          </TokenValidationProvider>
        </Router>
      </SelectionProvider>
      <ToastContainer />
    </JobsProvider>
  );
}

export default App;
